export default "__VITE_ASSET__b26188b2__"